import React, { Component, Suspense } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import { AuthProvider } from './views/authentication/auth'
import RequireAuth from './views/authentication/RequireAuth'
import './scss/style.scss'
import SenangPayRec from './views/pages/FPX/senangpayrec'
import PermissionUser from './views/pages/users/PermissionUser'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
const Dashboard = React.lazy(() => import('./views/dashboard/Dashboard'))

// Pages
const PayRecurring = React.lazy(() => import('./views/pages/FPX/senangpayrec'))
const Pay = React.lazy(() => import('./views/pages/FPX/pay'))
const GenerateLinkIPay = React.lazy(() => import('./views/pages/FPX/generatelinkipay'))
const GenerateLink = React.lazy(() => import('./views/pages/FPX/generatelink'))
const ReferralLink = React.lazy(() => import('./views/pages/FPX/referrallink'))
const ViewReferralLink = React.lazy(() => import('./views/pages/FPX/viewreflink'))
const ViewPR = React.lazy(() => import('./views/pages/FPX/viewprlink'))
const Transactions = React.lazy(() => import('./views/pages/FPX/transactions'))
const ViewPaymentLink = React.lazy(() => import('./views/pages/FPX/viewpaymentlink'))
const PR = React.lazy(() => import('./views/pages/FPX/pr'))
const Recurring = React.lazy(() => import('./views/pages/FPX/recurring'))
const CreateGroup = React.lazy(() => import('./views/pages/group/CreateGroup'))
const UpdateGroup = React.lazy(() => import('./views/pages/group/UpdateGroup'))
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Logout = React.lazy(() => import('./views/pages/login/Logout'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const AddUser = React.lazy(() => import('./views/pages/users/AddUser'))
const UpdateUser = React.lazy(() => import('./views/pages/users/UpdateUser'))
const UpdateAdmin = React.lazy(() => import('./views/pages/users/UpdateAdmin'))
const ViewUser = React.lazy(() => import('./views/pages/users/ViewUser'))
const ViewAdmin = React.lazy(() => import('./views/pages/users/ViewAdmin'))
const RegisterPay = React.lazy(() => import('./views/pages/FPX/registerpay'))
const SenangPay = React.lazy(() => import('./views/pages/FPX/formonsubmit'))
const IPay = React.lazy(() => import('./views/pages/FPX/ipay'))
const Receipt = React.lazy(() => import('./views/pages/FPX/receipt'))
const IPayReceipt = React.lazy(() => import('./views/pages/FPX/ipay_receipt'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))
const AddAdmin = React.lazy(() => import('./views/pages/users/AddAdmin'))

// Email App
const EmailApp = React.lazy(() => import('./views/apps/email/EmailApp'))

class App extends Component {
  render() {
    return (
      <HashRouter basename={'/'}>
        <AuthProvider>
          <Suspense fallback={loading}>
            <Routes>
              {/* Public routes - NO authentication required */}
              <Route path="/" element={<Login />} />
              <Route path="/logout" element={<Logout />} />
              <Route path="/receipt" element={<Receipt />} />
              <Route path="/ipay_receipt" element={<IPayReceipt />} />
              <Route path="/senangpay" element={<SenangPay />} />
              <Route path="/senangpayrec" element={<PayRecurring />} />
              <Route path="/recurring" element={<Recurring />} />
              <Route path="/generatelink" element={<GenerateLink />} />
              <Route path="/generatelinkipay" element={<GenerateLinkIPay />} />
              <Route path="/registerpay" element={<RegisterPay />} />
              <Route path="/pay" element={<Pay />} />
              <Route path="/ipay" element={<IPay />} />
              <Route path="/register" element={<Register />} />

              {/* Protected routes - authentication required */}
              <Route element={<RequireAuth />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/addgroup" element={<CreateGroup />} />
                <Route path="/adduser" element={<AddUser />} />
                <Route path="/addadmin" element={<AddAdmin />} />
                <Route path="/viewadmin" element={<ViewAdmin />} />
                <Route path="/updateadmin" element={<UpdateAdmin />} />
                <Route path="/viewprlink" element={<ViewPR />} />
                <Route path="/transactions" element={<Transactions />} />
                <Route path="/viewpaymentlink" element={<ViewPaymentLink />} />
                <Route path="/viewreflink" element={<ViewReferralLink />} />
                <Route path="/updateuser" element={<UpdateUser />} />
                <Route path="/viewuser" element={<ViewUser />} />
                <Route path="/permuser" element={<PermissionUser />} />
                <Route path="/log" element={<log />} />
                <Route path="/updategroup" element={<UpdateGroup />} />
                <Route path="/referrallink" element={<ReferralLink />} />
                <Route path="/pr" element={<PR />} />
              </Route>

              {/* 404 or default - keep this LAST */}
              <Route path="*" element={<DefaultLayout />} />
            </Routes>
          </Suspense>
        </AuthProvider>
      </HashRouter>
    )
  }
}

export default App

/*

                
                { <Route path="/register" element={<Register />} />
              <Route path="/404" element={<Page404 />} />
              <Route path="/500" element={<Page500 />} />
              <Route path="/apps/email/*" element={<EmailApp />} /> }
              <Route exact path="/404" name="Page 404" element={<Page404 />} />
              <Route exact path="/500" name="Page 500" element={<Page500 />} />
              <Route path="/apps/email/*" name="Email App" element={<EmailApp />} />*/
